export enum ENewUnityFormStep {
    RegistrationData = 1,
    Address = 2,
    Password = 3,
    Send = 4
}